export function isApiErrorWithCode(
	error: unknown
): error is { data: { error: string } } {
	if (typeof error === 'object' && error !== null && 'data' in error) {
		const data = (error as { data?: unknown }).data;
		return typeof data === 'object' && data !== null && 'error' in data;
	}
	return false;
}
